var _effectorFileName = "/src/page-content/login/components/login-form/model.ts";
import { createEvent, createStore, sample } from 'effector';
import { postLoginDataMutation } from '@/shared/api/auth/login/api';
import { LoginDto } from '@/shared/api/generated/model';
import { navigateToFx } from '@/shared/lib/effector/router';
export const loginDataSent = createEvent<LoginDto>({
  loc: {
    file: _effectorFileName,
    line: 7,
    column: 29
  },
  name: "loginDataSent",
  sid: "q2w2y5"
});
sample({
  and: [{
    clock: loginDataSent,
    target: postLoginDataMutation.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 9,
      column: 0
    },
    sid: "zigl2l"
  }
});
export const $isAuthenticated = createStore<boolean>(false, {
  loc: {
    file: _effectorFileName,
    line: 14,
    column: 32
  },
  name: "$isAuthenticated",
  sid: "2bnj5n"
});
sample({
  and: [{
    clock: postLoginDataMutation.finished.success,
    fn: data => data.result?.status === 200,
    target: $isAuthenticated
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 16,
      column: 0
    },
    sid: "vsxlcj"
  }
});

// Redirect after successful login
sample({
  and: [{
    clock: postLoginDataMutation.finished.success,
    target: navigateToFx.prepend(() => {
      // Check if there is a redirect parameter in the URL
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectTo = urlParams.get('redirect');
        if (redirectTo && redirectTo !== '/login') {
          return {
            url: redirectTo
          };
        }
      }

      // Default redirect to account
      return {
        url: '/account'
      };
    })
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 23,
      column: 0
    },
    sid: "w8btyn"
  }
});